var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"memory"},[(_vm.ifKeepAlive)?_c('keep-alive',[_c('router-view')],1):_vm._e(),(!_vm.ifKeepAlive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }